import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject, Subscription, timer } from 'rxjs';
import { AuthService } from '../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class IdleTimeoutService {
    private snackBar = inject(MatSnackBar);
    private userActivity: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private timeoutDuration = 25 * 60 * 1000; // Set timeout duration (1 minutes)
    private idleTimer: Subscription | undefined;
    private warningTime = 1 * 60 * 1000; // Set warning time before logout (1 minutes)

    constructor(
        private router: Router,
        private authService: AuthService
    ) { }

    // Method to reset idle timer whenever user activity is detected
    resetTimer() {
        if (this.idleTimer) {
            this.idleTimer.unsubscribe(); // Clear existing timer
        }

        // Start the timer
        this.idleTimer = timer(this.timeoutDuration).subscribe(() => {
            this.triggerTimeout();
        });
    }

    // This method will handle what happens when the timeout is triggered
    triggerTimeout() {
        this.logout();
    }

    // Handle user logout
    logout() {
        // Remove tokens, session data, etc.
        this.authService.logoutUser().subscribe({
            next: (response) => {
                if (response) {
                    this.openSnackBar("Your session has expired. Please login again", "Okay");
                    localStorage.clear();
                    this.router.navigate(['/app/login'], { replaceUrl: true });
                }
            },
            error: (error) => {
                this.openSnackBar("Your session has expired. Please login again", "Okay"); 
                localStorage.clear();
                this.router.navigate(['/app/login'], { replaceUrl: true });
            },
        });
    }

    openSnackBar(message: string, action?: string) {
        this.snackBar.open(message, action, { duration: 3 * 1000 }); // 3 seconds
    }

    // Subscribe to user activity (mouse, keypress events)
    trackUserActivity() {
        this.resetTimer(); // Initialize timer at app startup

        // Listen for user activity (mouse movements, key presses, etc.)
        window.addEventListener('mousemove', () => this.resetTimer());
        window.addEventListener('keydown', () => this.resetTimer());
    }
}
